module.exports = __webpack_public_path__ + "static/media/Aasimar.6152bd85.png";